import * as React from 'react';
import RcSteps from 'rc-steps';
import CheckOutlined from '@ant-design/icons/CheckOutlined';
import CloseOutlined from '@ant-design/icons/CloseOutlined';
import classNames from 'classnames';
import { ConfigConsumer } from '../config-provider';
let Steps = /** @class */ (() => {
    class Steps extends React.Component {
        constructor() {
            super(...arguments);
            this.renderSteps = ({ getPrefixCls, direction }) => {
                const prefixCls = getPrefixCls('steps', this.props.prefixCls);
                const iconPrefix = getPrefixCls('', this.props.iconPrefix);
                const className = classNames(this.props.className, {
                    [`${prefixCls}-rtl`]: direction === 'rtl',
                });
                const icons = {
                    finish: <CheckOutlined className={`${prefixCls}-finish-icon`}/>,
                    error: <CloseOutlined className={`${prefixCls}-error-icon`}/>,
                };
                return (<RcSteps icons={icons} {...this.props} prefixCls={prefixCls} iconPrefix={iconPrefix} className={className}/>);
            };
        }
        render() {
            return <ConfigConsumer>{this.renderSteps}</ConfigConsumer>;
        }
    }
    Steps.Step = RcSteps.Step;
    Steps.defaultProps = {
        current: 0,
    };
    return Steps;
})();
export default Steps;
